import React, { useState, useEffect } from "react";
import { Header_panel } from "../Useful/Useful";
import "./category.css";
import AddProvince from "./AddProvince";
import "../Useful/useful.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import "react-slidedown/lib/slidedown.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
// import Addimage from "../../image-add.png";

import TablePagination from "@material-ui/core/TablePagination";
import {
  ProvincegGet,
  ProvinceUpdate,
  ProvinceCreate,
  ProvinceDelete,
} from "../../fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import IconButton from "@material-ui/core/IconButton";
import { FcFullTrash, FcInspection } from "react-icons/fc";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export default function CategoryList(props) {
  let history = useHistory();
  const [flag, setflag] = useState(false);
  const [navid, setnavid] = useState("#navbarToggleExternalContentSettingAdd1");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [rowslength, setrowslength] = useState(0);
  const [idd, setId] = useState("");
  const [parentcategory, setParentCategory] = useState([]);
  const [render, setRender] = useState(false);

  useEffect(() => {
    getCategory();
  }, [page, rowsPerPage]);
  const scrollBackToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const getCategory = () => {
    setLoading(true);
    ProvincegGet(page, rowsPerPage)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setRows(responseJson.result);
        setrowslength(responseJson.count);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  const hendleSubmit = (data) => {
    setLoading(true);
    if (data !== undefined && data.id !== null && data.id !== "") {
      ProvinceUpdate(data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("استان  با موفقیت ویرایش  شد");
          }
          return response.json();
        })
        .then((response) => {
          setLoading(false);

          const WheresTheDev = (obj) => obj.id === data.id;
          const idx = rows.findIndex(WheresTheDev);
          rows.splice(idx, 1, data);
          setId("");
          history.push("/main/province");
        })
        .catch((error) => {
          setLoading(false);
          // toast.error("خطای ویرایش  تنظیمات", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    } else {
      setLoading(true);
      ProvinceCreate(data)
        .then((response) => {
          // if (response.success === false) {
          //   toast.error(response.message);
          // } else if (response.success === true) {
          //   toast.success(response.message);
          // }
          if (response.status === 200) {
            toast.success("استان  با موفقیت اضافه  شد");
          }
          return response.json();
        })
        .then((response) => {
          setLoading(false);
          data.id = response.result.id;
          data.parentName = response.result.parentName;
          setId("");
          setRender(!render);
          // data.picViewModel.url = response.result.imageUrl;
          rows.unshift(data);

          history.push("/main/province");
        })
        .catch((error) => {
          console.error(error);
          return null;
        });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const hendleDelet = (deleteId) => {
    confirmAlert({
      title: " حذف کردن ",
      message: "آیا میخواهید این استان  راحذف کنید؟",
      buttons: [
        {
          label: "تایید",
          onClick: () => {
            setLoading(true);

            ProvinceDelete(deleteId)
              .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                  console.log("succcess");
                  toast.success("استان  با موفقیت حذف  شد");
                }

                return response.json();
              })
              .then((responseJson) => {
                setRows(rows.filter((row) => row.id !== deleteId));
              })
              .catch((error) => {
                // setLoading(false);
                // toast.error("خطای حذف تنظیمات", {
                //   position: "bottom-center",
                //   autoClose: 5000,
                // });
                console.log(error);
              });
          },
        },
        {
          label: "لغو",
        },
      ],
    });
  };

  return (
    //add item
    <div>
      <AddProvince
        id={idd}
        onFormSubmit={(data) => hendleSubmit(data)}
        rows={rows}
        parentcategory={parentcategory}
        navid={navid}
      />
      <hr />
      {/* list item */}
      <div class="col-lg-12  mypanel shadow">
        <Header_panel
          title="لیست استان"
          idMenu="#navbarToggleExternalContentListItem"
        />
        <div className="d-flex justify-content-center">
          {loading && (
            <>
              <Spinner animation="grow" variant="info" size="lg" />
              <div> صفحه در حال بارگزاری است ...</div>
            </>
          )}
        </div>
        <div class="pos-f-t">
          <div class="collapse" id="navbarToggleExternalContentListItem">
            <div class="p-4 mytable">
              <table class="table table-striped rtltable mytable">
                <thead>
                  <tr>
                    <th>شماره</th>

                    <th>نام استان</th>

                    <th>ویرایش کردن</th>
                    <th> حذف کردن</th>
                  </tr>
                </thead>
                <tbody>
                  {rows
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <tr>
                          <td>{page * rowsPerPage + index + 1}</td>

                          <td> {row.name}</td>

                          <td>
                            <Link to={`/main/province/${row.id}`}>
                              <IconButton
                                data-toggle="collapse"
                                data-target={!flag ? navid : ""}
                                color="primary"
                                onClick={() => {
                                  scrollBackToTop();
                                  setId(row.id);
                                  setflag(true);
                                }}
                              >
                                <FcInspection />
                              </IconButton>
                            </Link>
                          </td>
                          <td>
                            <IconButton onClick={() => hendleDelet(row.id)}>
                              <FcFullTrash />
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <TablePagination
        rowsPerPageOptions={[5, 20, 50]}
        component="div"
        count={rowslength}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="تعداد نمایش :"
        nextIconButtonText="بعدی "
        backIconButtonText=" قبلی"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
}
